import { getRequirementId, isRequirementRef } from '../../../../../util/groupRequirement.util'

// A group requirement is just a name, so a "group:<name>" field value already carries its own
// readable label — this builds a { "group:<name>": name } lookup for every such value found, so a
// review screen can show the name instead of the raw sentinel.
const buildGroupRequirementOptionsMap = (values = []) =>
  Object.fromEntries(values.filter(isRequirementRef).map((value) => [value, getRequirementId(value)]))

export default buildGroupRequirementOptionsMap
